import React, { useState } from 'react';
import './apexoCommon.css';

export type RangeInterval = 'day' | 'week' | 'month' | 'year';

interface ChartsRangeSelectorProps {
  startDate: Date;
  endDate: Date;
  interval: RangeInterval;
  onRangeChange: (start: Date, end: Date) => void;
  onIntervalChange: (interval: RangeInterval) => void;
  darkMode?: boolean;
}

const INTERVALS: RangeInterval[] = ['day', 'week', 'month', 'year'];
const INTERVAL_ICONS: Record<RangeInterval, string> = {
  day: '📅',
  week: '🗓️',
  month: '📊',
  year: '📆'
};

export default function ChartsRangeSelector({
  startDate,
  endDate,
  interval,
  onRangeChange,
  onIntervalChange,
  darkMode = false,
}: ChartsRangeSelectorProps) {
  
  const textColor = darkMode ? '#e2e8f0' : '#334155';
  const iconColor = darkMode ? '#94a3b8' : '#64748b';

  const handleToggleInterval = () => {
    const currentIndex = INTERVALS.indexOf(interval);
    const nextIndex = (currentIndex + 1) % INTERVALS.length;
    onIntervalChange(INTERVALS[nextIndex]);
  };

  const formatDate = (d: Date) => {
    // Default to dd/MM/yyyy to match APEXO dart fallback
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}/${d.getFullYear()}`;
  };

  return (
    <div className="apexo-range-selector" style={{ color: textColor }}>
      <div className="apexo-rs-btn" onClick={() => {/* Mock Native Date Picker */}}>
        <span style={{ fontSize: '20px', color: iconColor }}>⏮️</span>
        <div className="apexo-rs-col">
          <span className="apexo-rs-label">Start</span>
          <span className="apexo-rs-value">{formatDate(startDate)}</span>
        </div>
      </div>

      <div className="apexo-rs-btn center" onClick={handleToggleInterval}>
        <div className="apexo-rs-col align-center">
          <span style={{ fontSize: '20px', color: iconColor }}>{INTERVAL_ICONS[interval]}</span>
          <span className="apexo-rs-value" style={{ marginTop: '4px' }}>
            1 {interval.charAt(0).toUpperCase() + interval.slice(1)}
          </span>
        </div>
      </div>

      <div className="apexo-rs-btn" onClick={() => {/* Mock Native Date Picker */}}>
        <div className="apexo-rs-col align-right">
          <span className="apexo-rs-label">End</span>
          <span className="apexo-rs-value">{formatDate(endDate)}</span>
        </div>
        <span style={{ fontSize: '20px', color: iconColor }}>⏭️</span>
      </div>
    </div>
  );
}
